import { BsSend } from "react-icons/bs";

export const SendIcon = ({ ...rest }) => {
  return <BsSend {...rest} />;
};
